// src/unAuth/components/CreatorTips.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHashtag,
  faListOl,
  faFont,
  faSearch,
  faLayerGroup,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import "./CreatorTips.css";

const tips = [
  {
    icon: faClock,
    title: "Always start with 0:00",
    text: "YouTube only shows chapter markers in the progress bar when the first timestamp starts at 0:00. If your intro is a few seconds long, use \"0:00 Introduction\" or \"0:00 Intro\" as the first line.",
  },
  {
    icon: faListOl,
    title: "Aim for 3–7 chapters per video",
    text: "Enough chapters help viewers jump to what they need; too many can feel cluttered. For most videos under 20 minutes, 4–6 well-chosen chapters work best. For long-form content, group by major topic rather than listing every tiny segment.",
  },
  {
    icon: faFont,
    title: "Use clear, descriptive labels",
    text: "Labels like \"How to set up\" or \"Troubleshooting\" are more useful than \"Part 1\" or \"Section A.\" Viewers often scan the list before watching—make it easy for them to find the part they care about.",
  },
  {
    icon: faSearch,
    title: "Put timestamps in the first 200 characters when you can",
    text: "YouTube sometimes surfaces timestamps in search snippets. Keeping your first few timestamps near the top of the description can help both discoverability and click-through from search.",
  },
  {
    icon: faLayerGroup,
    title: "Group long streams or webinars by topic",
    text: "For multi-hour streams, one timestamp per minute is too much. Summarize into 10–15 topic-based chapters (e.g. \"1:23:00 Q&A,\" \"2:10:00 Demo\") so viewers can navigate without scrolling through a huge list.",
  },
  {
    icon: faHashtag,
    title: "Generate as soon as your video has captions",
    text: "Run Timestampgn as soon as YouTube has finished processing captions. Your description can be ready when the video goes live, and you avoid having to revisit it later.",
  },
];

export default function CreatorTips() {
  return (
    <section className="creator-tips" id="creator-tips" data-animate="fade-up">
      <h2 className="creator-tips-title">Tips for YouTube creators</h2>
      <p className="creator-tips-intro">
        Practical advice to get the most out of timestamps and chapter markers
        in your video descriptions. Based on how YouTube surfaces and uses them.
      </p>
      <div className="creator-tips-grid reveal-stagger">
        {tips.map((tip, i) => (
          <article key={i} className="creator-tips-card">
            <div className="creator-tips-icon">
              <FontAwesomeIcon icon={tip.icon} />
            </div>
            <h3 className="creator-tips-card-title">{tip.title}</h3>
            <p className="creator-tips-card-text">{tip.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
